
import { ValidationResponse, ValidationSummary, ADPUpdaterMessageTypes,AppConfig, 
  OnlineConfig, ValidationResponseCheck} from "@npd-ng/adp-types";
import { checkStatus } from "./ServiceTypes";
export type NetworkConnectionTypes = "Internet" | "Offline" | "Router" | "RestrictedInternet" 
export type AssessmentMode =  "online" | "ncs" | "notselected" //"Internet" | "NPN" |  "NotSelected"
export type AppMode =  "Assess" | "Verify" | "NotSelected" | undefined
export type DeviceType = "SBE" | "NPE";
export type Views = "RedirectionView" | "LoadingErrorView" | "WaitView" | "WarningView" | "LoadingView" | "UpdaterView" | "ModeSelectionsView" | "DeviceValidationView" | "AccessCodeValidationView" | "DeviceValidationFailureView" | "VerificationCodeValidationView" | "DeviceValidationSuccessView" | "FailureView" | "RunningProccessFailureView"
export type LastKnownGoodState = "LoadingView" | "ModeSelectionsView" | "UpdaterView" | "DeviceValidationView" | "AccessCodeValidationView" | "RedirectToSCI" | "VerificationCodeValidationView"
export type ValidationState = undefined | "Verifying" | "Completed"
export type RuntimePlatform = "Electron" | "ChromeWithExtension" | "Browser";
export type UpdateStates = ADPUpdaterMessageTypesExtended;
export type FailureType =  "ApplicationError" | "NoNCSConnectionDetected" | "NoRouterConnectionDetected" | "NoServerConnectionDetected" | "NoInternetConnectionDetected" | "FailedHardwareCheck" | "SystemError" | "UpdateError" | "FailedSystemTimeCheck" | "FailedVersionCheck" | "ProccessCheckError" | "ChromeExtensionError"
export type PreCacheVaidationStatus = {
    validationStatus: ServiceWorkerValidationType,
    validationDetails: string
}
export type pingStages = "initilization" | "status"
export type pingResults = "success" | "failure" | "skipped"
export type ValidationResults = ValidationResponse & checkStatus;
export type appPhase = {
  name:  "ModeSelection"| "ResolvingLaunchMode" | "UpdateSessionDetails" | "Initilizing" | "NetworkCheck" | "DateTimeCheck" | "UpdateCheck" | "CodeVerification" | "DeviceValidation" | "TransitionToSCI" | "CacheValidation",
  status: "InProgress" | "Completed" | "NotStarted" | "Error" | "Skipped"
}
export interface IValidationSummary extends ValidationSummary {
  responses:Array<ValidationResults>
}
  export type UpdateComponents = {
    name: eNAEPComponents | "ADP-EXTENSION",
    version: string
}
export type CachedType = "Pending" | "WaitingForConfirmation" | "Completed" | "Failed"
export type RelaunchInformationType ={
  clientLaunchId?:string,
  loginId?:string,
  reason?:string
}
export type LaunchErrorType = {
  error:'DateTimeError' | 'ServerError' | 'CachingError' | "PingError"
  errorDetails: {
    errorMessage:string,
    timeStamp:Date,
  }
}

export interface IADPState {
    appState: {
        appLaunchTime: string,
        appLaunchId: string | undefined,
        appVersion: string ,
        appCode: string,
        appBuildDate: string | undefined,
        appPhases: appPhase[],
        currentPhase: appPhase["name"],
        releaseVersion: string | undefined,
        releaseBuildNumber: number,
        releaseColors: string[],
        releaseBorder: string[],
        environment: string | undefined,
        configuration: AppConfigExtended | undefined,
        currentView: Views,
        isPageReloaded: boolean,
        extensionVersion: string | undefined,
        expectedADCVersion: string | undefined,
        expectedSCIVersion: string | undefined,
        expectedADPVersion: string | undefined,
        isUnderMaintenance: boolean,
        serviceWorkersRegistered: boolean,
        runtimePlatform: {
            platform: RuntimePlatform,
            version: string,
            userAgent: string
        },
        selectedLanguage: "en" | "es",
        isCached: CachedType,
        apiDomain: string,
        resourcesLoaded:boolean,
        launchMode: "NPN" | "Internet" | "NotResolved",
        relaunchInformation?:RelaunchInformationType,
        serverDetails?: string
    }, 
    serviceWorkers?:ServiceWorkerType[],
    cacheValidation:{
        validationStatus: PreCacheVaidationStatus["validationStatus"],
        validationDetails?: PreCacheVaidationStatus["validationDetails"],
        validationEvents?:PreCacheVaidationStatus[],
    },
    updateState: {
        isCheckForUpdateEnabled: boolean,
        updateEvents?: IpcMessageType,
        appComponentVersions: UpdateComponents[],
        status: "NotStarted" | "Skipped" | "Completed" | "Failed"
    },
    deviceState:{
        batteryState: Battery,
        deviceId: string | undefined, 
        deviceIdType: "uuid" | "serial" | "mac" | "NotAvailable",
        deviceType: DeviceType,
        deviceModel: string | undefined,
        browserAgentData: any,
        systemInfo?: any,
        isDateTimeValid: boolean
    },
    sessionState: {
        selectedAssessmentMode: AssessmentMode,
        connectionType:ConnectionType,
        appAccessedFor: AppMode
        networkConnectionState: NetworkConnectionState,
        networkDetails?: NetworkConnectionStateObj,
        networkChangeEvents:NetworkConnectionStateObj[],
        schoolDetails: VerifySetUpCodeResponse | undefined,
        lastKnownGoodState: Views | undefined,
        providedCode:string | undefined,
        selectedAssessmentLocation: assessmentLocation | undefined,
        locationError:boolean,
        homeButtonEnabled: boolean,
        exitButtonEnabled : boolean,
        confirmationModal: boolean,
        failure?: FailureType,
        tryAgainAfterFailure: boolean,
        launchError?:LaunchErrorType
    },
    deviceReadinessState: {
        validationState: ValidationState,
        deviceVitalsInfo?: DeviceVitalsInfo[],
        deviceReadinessInfo?: DeviceReadinessInfo
        },
    deviceReadinessSummary: IValidationSummary | undefined,
    staticContent: {en:Content,es:Content} | undefined,
    currentLanguageContent: Content | undefined,
}
export type NPNConfig = {
  "protocol": string,
  "port": number,
  "ncsHealth": string,
  "defaultDomain": string
}
export type SessionDetails = {
  deviceId: string,
  appLaunchId: string,
  deviceIdType: "uuid" | "serial" | "mac" | "NotAvailable",
  deviceType: DeviceType,
  deviceModel: any | string,
  runtimePlatform: IADPState["appState"]["runtimePlatform"],
  isCheckForUpdateEnabled?: boolean,
  environment?:string,
  isPageReloaded: boolean,
  releaseVersion?: string,
  networkConnectionState?: NetworkConnectionState,
  networkConnectionDetails?: NetworkConnectionStateObj,
  systemInfo?:any,
  extensionVersion: string

}
export type GreetingDetails = {
  deviceId: string,
  appLaunchId: string,
  deviceType: DeviceType,
  deviceModel: any | string, 
  runtimePlatform: IADPState["appState"]["runtimePlatform"]
}
export type ADPUpdaterMessageTypesExtended = ADPUpdaterMessageTypes | "update-fast-forward" | "update-is-in-progress"
export type IpcMessageType = {
  type: ADPUpdaterMessageTypesExtended 
  message?: any
}
export type ExtensionRequests = "Greeting" | "CleanLocalStorage" |
  "StoreSessionData" | "RestartDevice" | "NetworkDetails" | "DeviceDetails" |  "DeviceSerialNumber" | "LaunchAdminBox" | "PlatformInfo" | "AudioDevice" | "HardwareInfo" | "PostChromeAppState" | "Ping";
export type ExtensionResponses = "Greeting"

export type ExtensionMessage = {
  type: ExtensionRequests,
  data?: any
}

export type ExtensionResponse = {
  type: ExtensionResponses,
  data?: any
}

export type Battery = {
    level:number, 
    charging:boolean,
}
export type ValidationChecks = 
  "checkBattery" |
  "checkConnection" |
  "checkCPU"|
  "checkMemory" |
  "checkStorage" | 
  "checkBrightness" |
  "checkProccessor" |
  "checkHardware" | 
  "checkVersions" | 
  "checkBrowserStorage" |
  "checkNCSVersions"|
  "checkCloudServerHealth" | 
  "checkNCSServerHealth" | 
  "checkRouterConnection" | 
  "checkSystemClock" | 
  "checkNCSSystemClock" | 
  "checkScreenResolution" | 
  "checkScreen" | 
  "checkOSVersion" | 
  "checkDuplicateScreen" | 
  "checkTouchDevice" | 
  "checkAspectRatio" | 
  "checkNCSEnv" | 
  "checkDevice" | 
  "checkChromeExtension" |
  "checkRunningProcesses" |
  "checkStudentComponents" |
  "checkDeviceId" |
  "checkContentFiltering" |
  "checkScriptPermissions" |
  "checkAppName"
  
  export type DeviceValidationChecks = {
  [key in ValidationChecks]: DeviceValdationCheck;
};


 type ConfigExtension = {
    enableUpdate: boolean,
    systemClockThreshold: number,
     versionColors:string[]
     versionBorderColors:string[],
     environment: string,
     heartbeatIntervalSec: number,
     onlineMode: "onlineServices" | "onlineServicesMulti",
     onlineServices: OnlineConfig,
     onlineServicesMulti: OnlineConfig,
     serviceWorkersToRegister: eNAEPComponents[],
     minBrowserStorageQuota: number,
     localCacheValidation: {
        maxRetryAttempts: number,
        pollingIntervalMs: number
    },
    enableLocation: boolean,
    ncsServices?: NPNConfig,
    deviceValidationChecks:{
      errorChecksPassed:boolean,
      onlineChecks:  DeviceValidationChecks,
      npnChecks: DeviceValidationChecks,
      deviceSharedChecks: DeviceValidationChecks
    }
    ping:{
      retryAttempts:number,
      retryTimeoutInMS:number,
      failurePoints:string[],
      errorScreen:FailureType | "WarningView",
      electronVersion:string
    }
    
   
}

export type OSThreshold = {
    os:string,
    name:string,
    checkOs:boolean,
    version:string
}

export type ManifestProps = {
    product: {
        versionColors:string[]
        versionBorderColors:string[]
        version:string,
        buildNumber: number,
    }
    app: {
        version: string,
        code: "ng-enaep-chrome-app",
        buildDate: string,
        }
    }
export type DeviceValdationCheck = {
    enabled:boolean,
    name:string,
    threshold:any,
    type:ValidationResponseCheck
}
export type AppConfigExtended = ConfigExtension & AppConfig

export type NetworkConnectionState = "Connected" | "N/A"
export type NetworkConnectionStateObj = {
    SSID? : string,
    address?: string
    connectionType: "Connected" | "N/A"
}
  type ErrorType = {
    title:string,
    content:string[],
    errorCode?:string
  };
  export type Content = {
    header:{
      BatteryWarning: {
        title: string;
        subTitle: string;
      }
      home:string;
      exit:string;
      version:string;
      enLangText:string;
      esLangText:string;
      router:string;
    }
    initialWait: {
      title: string;
      message: string;
      subTitle: string;
    }
    FailedToLoad:{
      title: string;
      message: string;
    }
    modeSelectionView: {
      title: string;
      assessmentDay: {
        label: string;
        content: string;
        actionDescription: string;
      };
      preAssessmentCheck: {
        label: string;
        content: string;
        actionDescription: string;
      };
    };
    accessCode: {
      title: string;
      subTitle:string;
      npnSubTitle: string,
      inputLabel:string;
      prefix:string;
      verifying:string;
      codeErrorText: string;
      locationTitle: string;
      locationErrorText:string;
      international1: string;
      international2: string;
      confirmationModal: {
        title: string;
        confirmText: string;
        cancelText: string;
      }
    }
    serverCode: {
      title: string;
      subTitle:string;
      inputLabel:string;
      prefix:string;
      verifying:string;
      codeErrorText: string;
    }
    loadAssessment:{
      title: string;
      message: string;
    }
    verificationCode: {
      title: string;
      subTitle:string;
      inputLabel:string
      prefix:string;
      verifying:string;
      codeErrorText: string;
      locationTitle: string;
      locationErrorText:string;
      international1: string;
      international2: string;
    };
    deviceValidationWait:{
      title: string;
      subTitle:string;
      message: string;
    }
    deviceValidationSuccess:{
      title: string;
      subTitle:string;
      notice:{
        title:string;
        message:string;
      };
    }
    deviceValidationFailure:{
      title:string;
      subTitle:string;
      notice:{
        title:string;
        assessTitle:string;
        message:string;
      };
      checkChromeExtension:string;
      checkMemory:string;
      checkScreenResolution:string;
      checkOSVersion:string;
      checkDuplicateScreen:string;
      checkProccessor:string;
      checkStorage:string;
      checkTouchScreen:string;
      checkInvalidResolution:string;
    }
    error: {
      NoNCSConnectionDetected: ErrorType;
      NoRouterConnectionDetected: ErrorType;
      NoServerConnectionDetected: ErrorType;
      NoInternetConnectionDetected: ErrorType;
      FailedHardwareCheck: ErrorType;
      SystemError: ErrorType;
      ChromeExtensionError: ErrorType;
      UpdateError: ErrorType;
      FailedSystemTimeCheck: ErrorType;
      FailedVersionCheck: ErrorType;
      ApplicationError: ErrorType;
      ProccessCheckError: ErrorType;
    }
    notifications: {
      updateChecking: string;
      updateNotFoundTitle: string;
      updateNotFoundSubTitle: string;
      updatesAvailableTitle: string;
      updatesReadyTitle: string;
      updatesEstimatedTimeText: string;
      updateStart: string;
      updateDownload: string;
      updateInstall: string;
      updatePrep: string;
      updateDelay: string;
      doNotCloseAppWarn: string;
      wait: string;
      restartInfo: string;
    };
    actions: {
      tryAgain: string;
      exit: string;
      close: string;
      resume: string;
      submit: string;
      continue: string;
      runChecks: string;
      finished: string;
      hideDetails: string;
      showDetails: string;
      apply: string;
      cancel: string,
      goBack: string 
    };
    adminAccessBox?:{
        title: string;
        deviceLabel: string;
        mainText: string;
        versionLabel: string;
        language: {
          spanish: string;
          english: string;
          instructions: string;
        };
        adminAccessBox: {
          header: {
            status: string;
            student: string;
          };
          warning: {
            title: string;
            description1: string;
            description2: string;
            description3: string;
            proceed1: string;
            proceed2: string;
          };
          login: {
            title: string;
            description: string;
            placeholder: string;
            invalid1: string;
            invalid2: string;
          };
          assessmentStatus: {
            Paused: string;
            InProgress: string;
            Completed: string;
            Interrupted: string;
          };
          dashboard: {
            title: string;
            description: string;
            defaultSelect: string;
            returnLink: string;
            returnMsg: string;
            actions: {
              close: {
                action: string;
                description: string;
              };
              shutDown: {
                action: string;
                description: string;
              };
              refresh: {
                action: string;
                description: string;
              };
              resume: {
                action: string;
                description: string;
              };
              release: {
                action: string;
                description: string;
              };
              skipToNextBlock: {
                action: string;
                description: string;
              };
              endAssessment: {
                action: string;
                description: string;
              };
              unlock: {
                action: string;
                description: string;
              };
            };
          };
        };
        assessmentLaunchModes: {
          online: {
            title: string;
            description: string;
          };
          ncs: {
            title: string;
            description: string;
          };
        };
        setupCode: {
          title: string;
          errorText: string;
          connecting: string;
        };
        notifications: {
          updateChecking: string;
          updateNotFoundTitle: string;
          updateNotFoundSubTitle: string;
          updateNotFoundRedirection: string;
          updatesAvailableTitle: string;
          updatesReadyTitle: string;
          updatesEstimatedTimeText: string;
          updateStart: string;
          updateDownload: string;
          updateInstall: string;
          updatePrep: string;
          updateDelay: string;
          doNotCloseAppWarn: string;
          wait: string;
          internetConnecting: string;
          restartInfo: string;
          exitingApplication: string;
          redirectToStudentWelcomeScreen: string;
          processingRequest: string;
          requestFailed: string;
          requestTime: string;
        };
        actions: {
          tryAgain: string;
          searchAgain: string;
          workOffline: string;
          cancel: string;
          cancelSearch: string;
          exit: string;
          goBack: string;
          shutdown: string;
          close: string;
          resume: string;
          submit: string;
          tryagain: string;
          skipStressTest: string;
          modeSelect: string;
          launchAssessment: string;
          goBackModeSelection: string;
          continue: string;
          apply: string;
        };
        connectionModeText: string;
        deviceReadiness: {
          title: string;
          networkTitle: string;
          validationTitle: string;
      
          NoNCSConnectionDetected: ErrorType;
          NoRouterConnectionDetected: ErrorType;
          NoServerConnectionDetected: ErrorType;
          NoInternetConnectionDetected: ErrorType;
          FailedHardwareCheck: ErrorType;
          SystemError: ErrorType;
          UpdateError: ErrorType;
          FailedSystemTimeCheck: ErrorType;
          FailedVersionCheck: ErrorType;
          FailedModeOneCheck: ErrorType;
          setupCode: {
            title: string;
            errorText: string;
            connecting: string;
            locationTitle: string;
          };
          BatteryWarning: {
            title: string;
            subTitle: string;
          };
          results: {
            title: string;
            launchMode: {
              online: {
                header: string;
                state: string;
                message: string;
              };
              ncs: {
                header: string;
                state: string;
                message: string;
              };
            };
            device: {
              success: {
                header: string;
                state: string;
                message: string;
              };
              warning: {
                header: string;
                state: string;
                message: string;
              };
            };
            stressTest: {
              title: string;
              success: {
                header: string;
                state: string;
                message: string;
              };
              wait: {
                header: string;
                state: string;
                message: string;
              };
              skipped: {
                header: string;
                state: string;
                message: string;
              };
              systemSkipped: {
                header: string;
                state: string;
                message: string;
              };
              networkError: {
                header: string;
                state: string;
                message: string;
              };
              systemError: {
                header: string;
                state: string;
                message: string;
              };
              incomplete: {
                header: string;
                state: string;
                message: string;
              };
              failed: {
                header: string;
                state: string;
                message: string;
              };
            };
            wait: {
              title: string;
              subTitle: string;
            }
          }
        }
      
      
    }
    imageAltText:{
      plugIcon:string,
      naepLogo:string,
      homeLogo:string,
      exitLogo:string,
      enLogo:string,
      esLogo:string,
      batteryIcon:string,
      batteryCharging:string,
      wifiIcon:string,
      wifiOffIcon:string,
      successIcon:string,
      failureTriangleIcon:string,
      failureCircleIcon:string,
      verifyingIcon:string,
      verificationActionIcon:string,
      assessmentDayActionIcon:string,
      questionMarkIcon:string,
      raiseHandIcon:string,
      closeIcon:string,
      batteryWarning:string
    }
  };
  
export type DeviceReadinessInfo = {
    readinessCheckStartedAt: string,
    deviceReadinessCheckPassed: boolean,           
    state: DeviceReadiness,
    failureReason: any [],
    readinessCheckCompletedAt:string       
}
export type DeviceVitalsInfo = {
  name:ValidationChecks,
  value:any
}
export type ConnectionType = "Internet" | "NPN"
export type DeviceMetrics ={
data: {
    clientLaunchId: string,
    appAccessedFor: AppMode
    setupCode: string | undefined,
    verificationCode: string | undefined,
    deviceModel: string,
    assessmentDeliveryMode:AssessmentMode
    connectionType: ConnectionType,
    launchAgent: string,
    readinessCheckInfo?: DeviceReadinessInfo,
    statusInfo: {
        currentBatteryCharge: string | number,
        lastUpdatedAt: string
    },
    assessmentLocation?:assessmentLocation  
},
clientDetails: {
  appName: string,
  appVersion: string,
  deviceDetails: {
      deviceType: DeviceType,
      deviceId: string,
      operatingSystem:string
  }
}
}
export type DeviceMetricsPatch ={
  data: {
      clientLaunchId: string,
      appAccessedFor: AppMode
      setupCode: string | undefined,
      verificationCode: string | undefined,
      connectionType: ConnectionType,
      launchAgent: string,
      deviceLocalTime: string,
      deviceLocalTimeZone:string,                            
      statusInfo: {
          currentBatteryCharge: string | number
      },
      assessmentLocation?:assessmentLocation  
  },
  clientDetails: {
    appName: string,
    appVersion: string,
    deviceDetails: {
        deviceType: DeviceType,
        deviceId: string,
        operatingSystem:string
    }
  }
}
export type DeviceReadiness = "DeviceStarted" |
"ReadinessCheckInProgress" |
"ReadinessCheckCompleted"


export type DeviceValidationRuleType = {
    checkBattery : ValidationResponse,
    checkConnection :  ValidationResponse,
    checkCPU :  ValidationResponse,
    checkMemory :  ValidationResponse,
    checkVersion :  ValidationResponse,
    checkCloudServerHealth : ValidationResponse,
    checkNCSServerHealth:  ValidationResponse,
    stressTest:  ValidationResponse,
    checkSystemClock: ValidationResponse,
}

export type VerifySetUpCodePayload = {
    adpLaunchId: string;
    deviceId: string;
    requestDateTime: string;
    setupCode: string | undefined;
    verificationCode?: string | undefined;
    appAccessedFor?: AppMode;
  };
  
      export type VerifySetUpCodeResponse = {
          status: string | number;
          error?: any;
          errorMessage?: string;
          errorCode?: string;
          isPR?: number;
          setupCode:string | undefined;
          verificationCode?: string | undefined;
          assessmentLocations?:assessmentLocation[];
          location?: string;
  } 
  export type assessmentLocation ={
          locationId:string;
          label:string;
  }  

  export enum eNAEPComponents {
    ADP = "ADP",
    SCI = "SCI",
    ADC = "ADC",
    ADP_NPN = "ADP_NPN",
    CHROME_EXTENSION = "CHROME_EXTENSION"
}
export type ServiceWorkerValidationType = "NotStarted" | "Pending" | "InProgress" | "Complete" | "Failed" | "Skipped"
export enum ServiceWorkerMessageType {
    POLL_PRECACHE_STATE = "POLL_PRECACHE_STATE",
    PRECACHE_COMPLETE = "PRECACHE_COMPLETE",
    PRECACHE_FAILURE = "PRECACHE_FAILURE",
    GET_APPLICATION_VERSION = "GET_APPLICATION_VERSION",
    PRECACHE_NOT_COMPLETE = "PRECACHE_NOT_COMPLETE",
  }
  
export type ServiceWorkerType = {
    appCode: eNAEPComponents,
    registrationStatus?: string,
    cachedVersion?: string,
    serverVersion?: string | undefined
    serverVersionError?: string
}